import React from 'react';
import PropTypes from 'prop-types';

class LinkIcon extends React.PureComponent {
	render() {
		const { width, height, fill, style } = this.props;

		const viewBox = [0, 0, width, height].join(' ');

		return (
			<svg width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
				<g fill={fill} transform="translate(-1.0, -1.0)">
					<path d="m14.2409061 7.75909392c.3579806.3579806.357079.93928341.0029832 1.29337922l-5.19141616 5.19141616c-.35633302.356333-.93290284.3574932-1.29337922-.0029832-.3579806-.3579806-.35707902-.9392834-.00298321-1.2933792l5.19141619-5.19141619c.356333-.35633302.9329028-.35749317 1.2933792.00298321zm-6.48179906 10.37088638c-1.07283162 1.0728316-2.81695418 1.0721593-3.88910042.0000131-1.07305011-1.0730501-1.07250674-2.8165806.00001312-3.8891004l2.59271175-2.5927118c.3579806-.3579806.3579806-.9383818 0-1.2963624-.3579806-.35798062-.93838183-.35798062-1.29636243 0l-2.59271175 2.5927117c-1.78830024 1.7883003-1.78920538 4.692633-.00001312 6.4818253 1.78788382 1.7878838 4.69280865 1.7890035 6.48182528-.0000131l2.59271173-2.5927118c.3579806-.3579806.3579806-.9383818 0-1.2963624s-.9383818-.3579806-1.2963624 0zm11.66723566-9.07451083c1.7890166-1.78901663 1.7878969-4.69394146.0000131-6.48182528-1.7891923-1.78919226-4.693525-1.78828712-6.4818253.00001312l-2.5927117 2.59271175c-.35798062.3579806-.35798062.93838183 0 1.29636243.3579806.3579806.9383818.3579806 1.2963624 0l2.5927118-2.59271175c1.0725198-1.07251986 2.8160503-1.07306323 3.8891004-.00001312 1.0721462 1.07214624 1.0728185 2.8162688-.0000131 3.88910042l-2.5927118 2.59271176c-.3579806.3579806-.3579806.9383818 0 1.2963624s.9383818.3579806 1.2963624 0z"/>
				</g>
			</svg>
		);
	}
}

LinkIcon.defaultProps = {
	width: 20,
	height: 20,
	fill: 'rgba(0, 0, 0, 0.16)',
};

LinkIcon.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	fill: PropTypes.string,
};

export default LinkIcon;



// WEBPACK FOOTER //
// ./src/components/shared/icons/linkIcon.js